import axios from 'axios';
export function getSouscripteurInformation(idSouscripteur) {
    return axios.get('/souscripteur/' + idSouscripteur);
}

export function getAssureInformation(numSecu) {
    return axios.get('/affilie/' + numSecu.replaceAll(' ', ''));
}

export function postFormAT(datas) {
    return axios.post('/arret_travail', datas);
}

export function postFile(file) {
    return axios.post(process.env.FILE_SERVER_UPLOAD_URL, file);
}

export function getArretTravail(page, limit) {
    return axios.get(`/arretTravailSuivi`, {
        params: {
            page,
            limit,
        },
    });
}
